<template>
  <div class="w-100 h-100 flex flex-column">
    <dv-border-box-12>
      <div class="h-100">
        <dv-scroll-board :config="config" />
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "frOverdue",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      startCharts: null,
      dataList: [],
      config: {
        startCharts: "",
        header: ["#", "超期措施", "责任人", "日期"],
        headerBGC: "#018DCE",
        evenRowBGC: "#000D4A",
        rowNum: 6,
        columnWidth: [200, 1000, 590, 120],
        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        for (var i = 0; i < this.dataList.length; i++) {
          var time = "--";
          var issue = this.dataList[i]["desc"];
          var owner = this.dataList[i]["user"];
          if (this.dataList[i]["dueDate"] > 0) {
            time = this.dateFormat(
              Number(this.dataList[i]["dueDate"]),
              "yyyy-MM-dd"
            );
          }
          if (!owner) {
            owner = "— —";
          }
          if (issue) {
            issue = issue.replace(/<[^>]+>/g, "");
          }
          var value = [(i + 1), issue, owner, time];
          data.push(value);
        }

        this.config = {
          startCharts: "",
          header: ["#", "超期措施", "责任人", "日期"],
          headerBGC: "#2C58A6",
          oddRowBGC: "rgba(0, 44, 81, 0.8)",
          evenRowBGC: "rgba(10, 29, 50, 0.8)",
          rowNum: 6,
          columnWidth: [200, 1000, 590, 120],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx) {
      return dateFormat(uninx, "yyyy/MM/dd");
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.4rem 0.2rem;
}

/*左边中间部分排行榜*/
.biaoge_pai {
  overflow: hidden;
}

.biaoge_pai ul li {
  height: 20%;
}

.biaoge_pai ul li .liIn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #fff;
  font-size: 0.06rem;
  height: 0.6rem;
}

.biaoge_pai ul li .liIn .liIn_left {
  width: 25%;
  position: relative;
  padding-left: 0.3rem;
}

.biaoge_pai ul li .liIn .liIn_left .bot {
  width: 0.2rem;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 1000px;
  display: block;
  position: absolute;
  left: 0.02rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.biaoge_pai ul li .liIn2 .liIn_left .bot {
  background: #e7feb8;
}

.biaoge_pai ul li .liIn3 .liIn_left .bot {
  background: #fdea8a;
}

.biaoge_pai ul li .liIn4 .liIn_left .bot {
  background: #8ff9f8;
}

.biaoge_pai ul li .liIn5 .liIn_left .bot {
  background: #91cc75;
}

.biaoge_pai ul li .liIn6 .liIn_left .bot {
  background: #05d1fc;
}

.biaoge_pai ul li .liIn .liIn_line {
  width: 58%;
  height: 0.2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2000px;
}

.biaoge_pai ul li .liIn .liIn_line .line_lineIn {
  width: 100%;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 100px;
  -webkit-animation: widthMove1 2s ease-in-out;
}

.biaoge_pai ul li .liIn2 .liIn_line .line_lineIn {
  background: #e7feb8;
  -webkit-animation: widthMove2 2s ease-in-out;
}

.biaoge_pai ul li .liIn3 .liIn_line .line_lineIn {
  background: #fdea8a;
  -webkit-animation: widthMove3 2s ease-in-out;
}

.biaoge_pai ul li .liIn4 .liIn_line .line_lineIn {
  background: #8ff9f8;
  -webkit-animation: widthMove4 2s ease-in-out;
}

.biaoge_pai ul li .liIn5 .liIn_line .line_lineIn {
  background: #d890fa;
  -webkit-animation: widthMove5 2s ease-in-out;
}

.biaoge_pai ul li .liIn6 .liIn_line .line_lineIn {
  background: #05d1fc;
  -webkit-animation: widthMove6 2s ease-in-out;
}

@-webkit-keyframes widthMove1 {
  0% {
    width: 0%;
  }

  100% {
    width: 98.5%;
  }
}

@-webkit-keyframes widthMove2 {
  0% {
    width: 0%;
  }

  100% {
    width: 88.5%;
  }
}

@-webkit-keyframes widthMove3 {
  0% {
    width: 0%;
  }

  100% {
    width: 68.5%;
  }
}

@-webkit-keyframes widthMove4 {
  0% {
    width: 0%;
  }

  100% {
    width: 40.5%;
  }
}

@-webkit-keyframes widthMove5 {
  0% {
    width: 0%;
  }

  100% {
    width: 22.5%;
  }
}

@-webkit-keyframes widthMove6 {
  0% {
    width: 0%;
  }

  100% {
    width: 10.5%;
  }
}

.biaoge_pai ul li .liIn .num {
  font-family: dig;
  padding-left: 0.1rem;
}</style>



// WEBPACK FOOTER //
// src/pages/fr/report/8d/component/issue-overdue.vue